<template>
    <div class="markdown-setting-wrapper">
        <iu-checkbox size="small" v-model="isDone" @change="onToggleDone(id, isDone)"></iu-checkbox>
        <div class="title">{{ title }}</div>
        <div class="currentDate">{{ parsedCurrentDate }}</div>
        <!-- <div class="createdDate">Created At: {{ parsedCreatedDate }}</div> -->
    </div>
</template>

<script>
import utils from '@/utils';

export default {
    props: {
        isChecked: {
            type: Boolean,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        createdDate: {
            type: Date,
            required: true,
        },
        currentDate: {
            type: Date,
            required: true,
        },
        onToggleDone: {
            type: Function,
        },
    },
    data() {
        return {
            isDone: this.isChecked,
        };
    },
    computed: {
        parsedCreatedDate() {
            return utils.date.parseDateToFormat(this.createdDate);
        },
        parsedCurrentDate() {
            return utils.date.parseDateToFormat(this.currentDate);
        },
    },
    watch: {
        isChecked: function() {
            this.isDone = this.isChecked;
        },
    },
};
</script>

<style lang="scss" scope>
.markdown-setting-wrapper {
    padding: 0 0 20px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    .title {
        margin: 0 10px;
        font-size: 1.5rem;

        &::after {
            content: '';
            border-right: 1px solid #ddd;
            margin-left: 10px;
        }
    }
    .currentDate {
        font-size: 1.2rem;
    }
    .createdDate {
        margin: 0 0 0 10px;
    }
}
</style>
